<template>
    <div>
        <div class="w3-modal" :class="{'show':modal === 1}">
            <div class="w3-modal-content">
                <div class="top-bar primary">
                    <button class="w3-button" style="margin: 6px" @click="() => {modal = 0; term = ''}">
                        <span class="w3-small">Cancelar</span>
                    </button>
                </div>
                <div class="w3-padding w3-padding-16">
                    <div>
                        <div class="w3-center"><b>Selecione seu usuário</b></div>
                        <div class="w3-margin-top" style="position: relative;">
                            <i class="fa fa-times w3-padding" @click="limparSearch(input)" style="position: absolute; right: 6px; top: 3px; cursor: pointer" v-show="term.trim() !== ''"></i>
                            <input type="text" class="w3-input w3-border" :id="input" v-model="term"
                                   @keyup="pesquisar()"
                                   @keyup.enter="searchResults.length === 1 ? selecionar(searchResults[0]) : ''"
                                   placeholder="Nome ou email.."
                                   autocomplete="new-street-address">
                        </div>
                    </div>
                    <div class="w3-margin-top w3-small">
                        <div class="w3-border box-container" v-show="term.trim() !== ''">
                            <a href="javascript:" class="w3-padding w3-padding-16 w3-block w3-border-bottom" v-for="r in searchResults" @click="selecionar(r)">
                                {{r.nome}}
                            </a>

                            <div class="w3-display-middle w3-center" v-show="searchResults.length === 0">
                                <i class="fa fa-frown-o fa-2x w3-padding"></i> <br>
                                Não encontrado resultados!
                            </div>

                        </div>

                        <div class="w3-border box-container" v-show="term.trim() === ''">
                            <a href="javascript:" class="w3-padding w3-padding-16 w3-block w3-border-bottom" v-for="r in usuarios" @click="selecionar(r)">
                                {{r.nome}}
                            </a>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="w3-modal" :class="{'show': modal === 2}">
            <div class="w3-modal-content">
                <div class="top-bar primary">
                    <button class="w3-button" style="margin: 6px" @click="() => {modal = 0}">
                        <span class="w3-small">Cancelar</span>
                    </button>
                </div>
                <div class="w3-padding-large w3-padding-16">
                    <div class="w3-center"><b>Digite sua senha</b></div>
                    <div class="w3-card w3-white w3-round w3-margin-top w3-padding-16">
                        <div class="display ">
                            {{key | password}}&nbsp;
                        </div>
                        <div class="keyboard">
                            <table class="w3-table w3-centered w3-bordered">
                                <tr>
                                    <td @click="selNumber(1)">1</td>
                                    <td @click="selNumber(2)">2</td>
                                    <td @click="selNumber(3)">3</td>
                                </tr>
                                <tr>
                                    <td @click="selNumber(4)">4</td>
                                    <td @click="selNumber(5)">5</td>
                                    <td @click="selNumber(6)">6</td>
                                </tr>
                                <tr>
                                    <td @click="selNumber(7)">7</td>
                                    <td @click="selNumber(8)">8</td>
                                    <td @click="selNumber(9)">9</td>
                                </tr>
                                <tr>
                                    <td @click="clearNumber()" class="w3-text-red"><i class="fa fa-eraser"></i></td>
                                    <td @click="selNumber(0)">0</td>
                                    <td @click="logar()" class="w3-text-green"><i class="fa fa-chevron-right"></i></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Logar",
        data() {
            return {
                modal: false,
                token: localStorage.getItem('key'),
                term: '',
                usuarios: [],
                searchResults: [],
                key: '',

                input: ID(),

                dados: {
                    usuario: '',
                    senha: ''
                }
            }
        },
        methods: {
            buscarUsuarios() {
                this.$http.get(base_url + 'usuarios/' + this.token)
                    .then(response => {
                        this.usuarios = response.data;
                        closeLoading();

                    }, res => {
                        closeLoading();
                    });
            },

            pesquisar() {
                let keys = [
                    "nome",
                    "email"
                ];

                let options = {
                    shouldSort: true,
                    threshold: 0.2,
                    location: 0,
                    distance: 100,
                    maxPatternLength: 32,
                    minMatchCharLength: 1,
                    keys: keys
                };

                this.$search(this.term, this.usuarios, options).then(results => {
                    this.searchResults = results;
                })
            },

            limparSearch() {
                this.term = '';
            },

            selecionar(u) {
                this.dados.usuario = u.usuario;
                this.modal = 2;
            },

            selNumber(n) {
                this.key += n;
            },

            clearNumber() {
                this.key = ''
            },

            logar() {
                openOnload();
                this.dados.senha = this.key;
                this.$http.post(base_url + 'autenticar', this.dados, {emulateJSON: true})
                    .then(res => {
                        if (res.data.success) {
                            setTimeout(() => {
                                closeOnload();
                                this.clearNumber();
                                this.$router.push("/market/" + res.data.token);
                            }, 500);

                        } else {
                            closeOnload();
                            this.clearNumber();
                        }

                    }, res => {
                        this.clearNumber();
                        closeOnload();
                        openModalMsg(res.data.result,res.data.msg);
                    });
            }
        },

        mounted() {
            this.buscarUsuarios();
        },

        created() {
            this.$parent.$on('openLogin', () => {
                this.modal = 1
            });
        },

        filters: {
            password(value) {
                if (value !== null || value !== undefined) {
                    return value.replace(/./g, '*');
                }
            }
        }
    }
</script>

<style scoped>
    .display {
        padding: 16px;
        border-radius: 4px;
        background-color: #3a3a3a;
        margin: 12px;
        color: #f44336;
        font-weight: bold;
        font-size: 16px;
    }
    .keyboard {
        padding: 12px;
    }
    .keyboard tr td{
        cursor: pointer;
        box-shadow: 3px 5px 5px -1px rgba(148,148,148,1);
        width: 33%;
    }
    .keyboard tr td:last-child{
        box-shadow: 3px 5px 5px -1px rgba(148,148,148,1);
    }
</style>



// WEBPACK FOOTER //
// src/components/commons/Logar.vue